import axios from 'axios';

// Vercel Redeploy Trigger 1

// Use your new Python Backend URL here once deployed (e.g., from Hugging Face or Render)
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const FINNHUB_BASE_URL = 'https://finnhub.io/api/v1';
const FINNHUB_API_KEY = process.env.REACT_APP_API_KEY;

/**
 * Fetches the current price of a US stock.
 * Prioritizes your Custom Python Backend (yfinance) if BACKEND_URL is set.
 * Falls back to Finnhub as a backup.
 * @param {string} symbol - The stock ticker (e.g., 'AAPL').
 * @returns {Promise<Object>} - The current price and previous close.
 */
export const fetchStockPrice = async (symbol) => {
    try {
        // 1. Try Custom Python Backend first if configured
        if (BACKEND_URL) {
            const response = await axios.get(`${BACKEND_URL}/price/${symbol.toUpperCase()}`);
            return {
                actual_price: response.data.actual_price,
                previous_close: response.data.previous_close
            };
        }

        // 2. Fallback to Finnhub (as originally implemented)
        const response = await axios.get(`${FINNHUB_BASE_URL}/quote`, {
            params: {
                symbol: symbol.toUpperCase(),
                token: FINNHUB_API_KEY,
            },
        });
        return {
            actual_price: response.data.c,
            previous_close: response.data.pc
        };
    } catch (error) {
        console.error(`Error fetching price for ${symbol}:`, error);
        return null;
    }
};

/**
 * Fetches the current CCL Dollar rate from DolarApi.com.
 * @returns {Promise<number>} - The current CCL rate.
 */
export const fetchBulkPrices = async (tickers) => {
    try {
        if (BACKEND_URL) {
            const response = await axios.post(`${BACKEND_URL}/prices`, tickers);
            return response.data;
        }
        return null;
    } catch (error) {
        console.error(`Error fetching bulk prices:`, error);
        return null;
    }
};

export const fetchDolarCCL = async () => {
    try {
        const response = await axios.get('https://dolarapi.com/v1/dolares/contadoconliqui');
        return response.data.compra; // Or 'venta', or average. 'compra' is safer for calculations.
    } catch (error) {
        console.error('Error fetching Dolar CCL:', error);
        return 1100; // Fallback value
    }
};
